








































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import DxButton from "devextreme-vue/button";
import TableSelectCodigoDescripcion from "@/components/DinamicallyForm/TableSelectCodigoDescripcion.vue";
import { centros } from "@/shared/dtos/centros";
import centrosModule from "@/store/modules/centros-module";

import DxTagBox from "devextreme-vue/tag-box";

// Definición de interfaces para Google Maps
declare global {
  interface Window {
    google: any;
  }
}

// Interfaces para los tipos de Google Maps
interface GoogleMapMarker {
  position: {
    lat: number;
    lng: number;
  };
  info: any;
  nombre: string;
  id: number;
  isCustomPoint?: boolean; // Para identificar puntos de inicio/fin personalizados
  type?: "start" | "end" | "center"; // Tipo de marcador
}

interface InfoWindowContent {
  info?: any;
  nombre?: string;
}

interface Place {
  geometry: {
    location: {
      lat: () => number;
      lng: () => number;
    };
  };
  formatted_address: string;
  name: string;
}

// Nueva interfaz para puntos de la ruta
interface PuntoRuta {
  nombre: string;
  direccion?: string;
  posicion: string;
  type: "start" | "center" | "end";
  distanciaAlSiguiente?: number; // en metros
  tiempoAlSiguiente?: number; // en segundos
  lat: number;
  lng: number;
}

import DxDropDownBox from "devextreme-vue/drop-down-box";
import DxTreeView from "devextreme-vue/tree-view";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
} from "devextreme-vue/data-grid";

@Component({
  $_veeValidate: { validator: "new" },
  components: {
    DxButton,
    DxTagBox,
    DxDropDownBox,
    DxTreeView,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
    TableSelectCodigoDescripcion,
  },
})
export default class RutaCentrosGps extends Vue {
  public center = { lat: 39.399548026808425, lng: -0.4157916279543559 };
  public zoom = 6.5;
  public selectedCentros: number[] = []; // Centros seleccionados
  public searchInput: string = ""; // Control del texto de búsqueda
  public startLocation: { lat: number; lng: number } | null = null; // Punto de inicio
  public endLocation: { lat: number; lng: number } | null = null; // Punto final
  public startLocationName: string = ""; // Nombre del punto de inicio
  public endLocationName: string = ""; // Nombre del punto final
  public customMarkers: GoogleMapMarker[] = []; // Marcadores personalizados (inicio/fin)
  public gridBoxValue: [] = []; // Valor del grid box
  public selectedCentros_DropDown: [] = []; // Valor del grid box 2

  // Nuevas propiedades para detalles de la ruta
  public rutaCalculada: boolean = false;
  public puntosRuta: PuntoRuta[] = [];
  public distanciaTotal: number = 0; // en metros
  public tiempoTotal: number = 0; // en segundos
  public consumoGasolina: number = 7; // L/100km
  public precioGasolina: number = 1.5; // €/L
  //public costoGasolina: number = 0; // € totales

  updateSelectedCentros(e: any) {
    // Actualiza la lista de centros seleccionados al cambiar el valor del DropDownBox
    this.selectedCentros = e.value;
  }
  selectionChanged(e: any) {
    // Actualiza la lista de centros seleccionados al cambiar la selección en el DataGrid
    this.selectedCentros_DropDown = e.selectedRowKeys;
    this.selectedCentros = []; // Reinicia la lista de centros seleccionados
    for (let index = 0; index < e.selectedRowKeys.length; index++) {
      const element = e.selectedRowKeys[index];
      this.selectedCentros.push(Number.parseInt(element.id)); // Agrega el ID del centro seleccionado
    }
  }
  getDisplayText() {
    // Si no hay elementos seleccionados, retornamos vacío
    if (!this.selectedCentros || !this.selectedCentros.length) {
      return "";
    }
    // Filtrar los elementos seleccionados y mostrar sus nombres
    const selectedItems = this.centrosOptions.filter((item) =>
      this.selectedCentros.includes(item.id)
    );

    return selectedItems.map((item) => item.nombre).join(", ");
  }
  public get centrosOptions() {
    return centrosModule.centroses; // Lista de centros
  }

  async created() {
    await centrosModule.getcentroses();
  }

  get markers(): GoogleMapMarker[] {
    return centrosModule.centroses.map((x: centros) => {
      return {
        position: {
          lat: Number.parseFloat(x.latitud.replace(",", ".")),
          lng: Number.parseFloat(x.longitud.replace(",", ".")),
        },
        info: x.toJson(),
        nombre: x.nombre,
        id: x.id,
      };
    });
  }

  get filteredMarkers(): GoogleMapMarker[] {
    // Combinar marcadores de centros seleccionados con puntos de inicio/fin
    let result: GoogleMapMarker[] = [];

    // Añadir centros seleccionados
    if (this.selectedCentros.length > 0) {
      result = this.markers.filter((marker) =>
        this.selectedCentros.includes(marker.id)
      );
    }

    // Añadir marcadores personalizados (inicio/fin)
    return [...result, ...this.customMarkers];
  }

  public infoWindowOpened = false;
  public infoWindowOptions = {
    pixelOffset: { width: 0, height: -30 }, // Utilizaremos typings correctos
  };
  public infoWindowPosition: { lat: number; lng: number } | null = null;
  public infoWindowContent: InfoWindowContent = {};

  public clearSearchInput(value: string) {
    // Limpia el texto de búsqueda después de seleccionar un ítem
    if (this.selectedCentros.includes(Number(value))) {
      this.searchInput = "";
    }
  }

  openInfoWindow(index: number) {
    const marker = this.filteredMarkers[index];
    if (marker) {
      this.infoWindowPosition = marker.position;
      this.infoWindowContent = {
        info: marker.info,
        nombre: marker.nombre,
      };
      this.infoWindowOpened = true;
    }
  }

  closeInfoWindow() {
    this.infoWindowOpened = false;
  }

  customMarker(type?: "start" | "end" | "center") {
    // Definir diferentes iconos para diferentes tipos de marcadores
    const icons = {
      start: {
        url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
        scaledSize: { width: 50, height: 50 },
      },
      end: {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        scaledSize: { width: 50, height: 50 },
      },
      center: {
        url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        scaledSize: { width: 50, height: 50 },
      },
    };

    // Usar el tipo especificado o 'center' como valor predeterminado
    const markerType = type || "center";
    return icons[markerType];
  }

  // Métodos para manejar la selección de puntos de inicio y fin
  setStartLocation(place: Place) {
    if (!place || !place.geometry) return;

    this.startLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };

    // Guardar nombre para mostrar en la UI
    this.startLocationName = place.name || place.formatted_address;

    // Actualizar marcador personalizado
    this.updateCustomMarker(
      "start",
      this.startLocation,
      this.startLocationName
    );

    // Centrar el mapa en el punto seleccionado
    this.center = this.startLocation;
    this.zoom = 12;
  }

  setEndLocation(place: Place) {
    if (!place || !place.geometry) return;

    this.endLocation = {
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    };

    // Guardar nombre para mostrar en la UI
    this.endLocationName = place.name || place.formatted_address;

    // Actualizar marcador personalizado
    this.updateCustomMarker("end", this.endLocation, this.endLocationName);
  }

  updateCustomMarker(
    type: "start" | "end",
    position: { lat: number; lng: number },
    nombre: string
  ) {
    // Eliminar marcador anterior del mismo tipo
    this.customMarkers = this.customMarkers.filter((m) => m.type !== type);

    // Añadir nuevo marcador
    this.customMarkers.push({
      position,
      info: {},
      nombre,
      id: type === "start" ? -1 : -2, // IDs negativos para diferenciarlos
      isCustomPoint: true,
      type,
    });
  }

  // Métodos para formatear distancias y tiempos
  formatDistance(metros: number | undefined): string {
    if (metros === undefined) return "";
    if (metros < 1000) {
      return `${metros} m`;
    } else {
      return `${(metros / 1000).toFixed(1)} km`;
    }
  }

  formatTime(segundos: number | undefined): string {
    if (segundos === undefined) return "";
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);

    if (horas > 0) {
      return `${horas}h ${minutos}min`;
    } else {
      return `${minutos} min`;
    }
  }

  getColorForType(type: string): string {
    const colors = {
      start: "green",
      center: "blue",
      end: "red",
    };
    return colors[type as keyof typeof colors] || "grey";
  }

  getIconForType(type: string): string {
    const icons = {
      start: "mdi-flag-checkered",
      center: "mdi-map-marker",
      end: "mdi-flag",
    };
    return icons[type as keyof typeof icons] || "mdi-circle-small";
  }

  public calcularRuta() {
    // Verificar que tenemos suficientes puntos para una ruta
    const centerMarkers =
      this.selectedCentros.length > 0
        ? this.markers.filter((marker) =>
            this.selectedCentros.includes(marker.id)
          )
        : [];
    //Hay que verificar que no nos pasamos de los  25 puntos contado inicio y fin
    if (centerMarkers.length > 23) {
      alert("No se puede calcular la ruta con mas de 23 centros");
      return;
    }

    // Acceso seguro a la API de Google Maps
    if (!window.google || !window.google.maps) {
      console.error("Google Maps API no está disponible");
      return;
    }

    const directionsService = new window.google.maps.DirectionsService();
    const directionsRenderer = new window.google.maps.DirectionsRenderer();

    // Acceder al objeto de mapa de forma segura
    const mapRef = this.$refs.map as Vue & { $mapObject: any };
    if (!mapRef || !mapRef.$mapObject) {
      console.error("No se pudo acceder al objeto de mapa");
      return;
    }

    directionsRenderer.setMap(mapRef.$mapObject);

    // Determinar origen y destino
    let origin, destination;

    // Si hay punto de inicio personalizado, usarlo como origen
    if (this.startLocation) {
      origin = new window.google.maps.LatLng(
        this.startLocation.lat,
        this.startLocation.lng
      );
    } else if (centerMarkers.length > 0) {
      // Si no hay punto de inicio pero hay centros seleccionados, usar el primer centro
      origin = new window.google.maps.LatLng(
        centerMarkers[0].position.lat,
        centerMarkers[0].position.lng
      );
    } else {
      alert("Se necesita un punto de inicio para la ruta");
      return;
    }

    // Si hay punto de fin personalizado, usarlo como destino
    if (this.endLocation) {
      destination = new window.google.maps.LatLng(
        this.endLocation.lat,
        this.endLocation.lng
      );
    } else if (centerMarkers.length > 0) {
      // Si no hay punto de fin pero hay centros seleccionados, usar el último centro
      destination = new window.google.maps.LatLng(
        centerMarkers[centerMarkers.length - 1].position.lat,
        centerMarkers[centerMarkers.length - 1].position.lng
      );
    } else {
      alert("Se necesita un punto de destino para la ruta");
      return;
    }

    // Crear waypoints para la ruta (centros seleccionados)
    const waypoints = centerMarkers
      .slice(
        this.startLocation ? 0 : 1, // Si hay punto de inicio personalizado, incluir todos los centros
        this.endLocation ? centerMarkers.length : centerMarkers.length - 1 // Si hay punto de fin personalizado, incluir todos los centros
      )
      .map((marker) => ({
        location: new window.google.maps.LatLng(
          marker.position.lat,
          marker.position.lng
        ),
        stopover: true,
      }));

    const request = {
      origin,
      destination,
      waypoints,
      travelMode: window.google.maps.TravelMode.DRIVING,
    };

    directionsService.route(request, (result: any, status: string) => {
      if (status === window.google.maps.DirectionsStatus.OK) {
        directionsRenderer.setDirections(result);
        this.procesarResultadoRuta(result);
      } else {
        alert("No se pudo calcular la ruta: " + status);
      }
    });
  }
  // En tu componente, dentro de la clase
  async geocodePosition(lat: number, lng: number): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!window.google || !window.google.maps) {
        console.error("Google Maps API no está disponible");
        resolve(`${lat}, ${lng}`);
        return;
      }

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { location: { lat, lng } },
        (results: any[], status: string) => {
          if (status === "OK" && results[0]) {
            resolve(results[0].formatted_address);
          } else {
            console.error("Geocoder falló:", status);
            resolve(`${lat}, ${lng}`);
          }
        }
      );
    });
  }

  async procesarResultadoRuta(result: any) {
    // Reiniciar datos
    this.puntosRuta = [];
    this.distanciaTotal = 0;
    this.tiempoTotal = 0;

    if (!result.routes || result.routes.length === 0) {
      console.error("No se encontraron rutas");
      return;
    }

    const route = result.routes[0];
    const legs = route.legs;

    // Procesar cada tramo de la ruta
    for (let i = 0; i < legs.length; i++) {
      const leg = legs[i];

      // Agregar punto de origen (solo para el primer tramo o si es personalizado)
      if (i === 0) {
        const isStartCustom = this.startLocation !== null;
        const startPoint: PuntoRuta = {
          nombre: isStartCustom ? this.startLocationName : leg.start_address,
          posicion: `${leg.start_location.lat()}, ${leg.start_location.lng()}`,
          type: "start",
          lat: leg.start_location.lat(),
          lng: leg.start_location.lng(),
        };

        if (leg.distance && leg.duration) {
          startPoint.distanciaAlSiguiente = leg.distance.value;
          startPoint.tiempoAlSiguiente = leg.duration.value;
        }

        this.puntosRuta.push(startPoint);
      }

      // Agregar puntos intermedios
      if (i < legs.length - 1 || !this.endLocation) {
        // Buscar el centro correspondiente
        const centroEncontrado =
          this.selectedCentros.length > i
            ? centrosModule.centroses.find(
                (c) => c.id === this.selectedCentros[i]
              )
            : null;

        const centerPoint: PuntoRuta = {
          nombre: centroEncontrado ? centroEncontrado.nombre : leg.end_address,
          direccion: await this.geocodePosition(
            leg.end_location.lat(),
            leg.end_location.lng()
          ), //centroEncontrado ? centroEncontrado.direccion : undefined,
          posicion: `${leg.end_location.lat()}, ${leg.end_location.lng()}`,
          type: "center",
          lat: leg.end_location.lat(),
          lng: leg.end_location.lng(),
        };

        // Si no es el último tramo, agregar distancia y tiempo al siguiente
        if (i < legs.length - 1) {
          const nextLeg = legs[i + 1];
          centerPoint.distanciaAlSiguiente = nextLeg.distance.value;
          centerPoint.tiempoAlSiguiente = nextLeg.duration.value;
        }

        this.puntosRuta.push(centerPoint);
      }

      // Agregar punto final (solo para el último tramo y si es personalizado)
      if (i === legs.length - 1 && this.endLocation) {
        const endPoint: PuntoRuta = {
          nombre: this.endLocationName,
          posicion: `${leg.end_location.lat()}, ${leg.end_location.lng()}`,
          type: "end",
          lat: leg.end_location.lat(),
          lng: leg.end_location.lng(),
        };

        this.puntosRuta.push(endPoint);
      }

      // Acumular distancia y tiempo totales
      if (leg.distance && leg.duration) {
        this.distanciaTotal += leg.distance.value;
        this.tiempoTotal += leg.duration.value;
      }
    }

    // Calcular costo de gasolina
    // Fórmula: (distancia en km) * (consumo en L/100km) / 100 * (precio por litro)
    /* this.costoGasolina =
      (this.distanciaTotal / 1000) *
      (this.consumoGasolina / 100) *
      this.precioGasolina;*/

    // Marcar que la ruta ha sido calculada
    this.rutaCalculada = true;
  }

  get costoGasolina() {
    return (
      (this.distanciaTotal / 1000) *
      (this.consumoGasolina / 100) *
      this.precioGasolina
    );
  }
}
